import { supabase } from '../lib/supabaseClient';
import type { MyContext } from '../types/domain';

/**
 * Calls the real `fn_get_my_context()` RPC (migration 0032) — the server-side
 * "/me" resolution. Never resolves identity/tenant/roles from the JWT
 * client-side; the server is the single source of truth, exactly as it is
 * for every other DEV_TESTED function in this project.
 *
 * STATUS: IMPLEMENTED_UNVERIFIED — see docs/data-dictionary.md §8k. This
 * function's server-side counterpart (fn_get_my_context) is itself
 * DEV_TESTED (test13_rbac_vertical_slice1.sql §A1-A2, 2/2 PASS); what is
 * unverified is only this browser-side call wrapping it.
 */
export async function fetchMyContext(): Promise<MyContext> {
  const { data, error } = await supabase.rpc('fn_get_my_context');
  if (error) {
    throw new Error(`fn_get_my_context failed: ${error.message}`);
  }
  return data as MyContext;
}
